import { render, staticRenderFns } from "./ConsumptionList.vue?vue&type=template&id=ef5e30e4&"
import script from "./ConsumptionList.vue?vue&type=script&lang=js&"
export * from "./ConsumptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ConsumptionList.vue"
export default component.exports